module.exports = __webpack_public_path__ + "static/fonts/Rubik-Regular.db5c7ab.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Rubik-Regular.ttf
// module id = 9B5v
// module chunks = 0